import { OVERALL_META, STATUS_META } from "@/lib/checklist";

export function StatusBadge({ status, testid }) {
  const meta = STATUS_META[status] || STATUS_META.missing;
  return (
    <span
      data-testid={testid || `status-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${meta.className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} />
      {meta.label}
    </span>
  );
}

export function OverallBadge({ overall, testid }) {
  const meta = OVERALL_META[overall] || OVERALL_META.outstanding;
  return (
    <span
      data-testid={testid || `overall-${overall}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold ${meta.className}`}
    >
      {meta.label}
    </span>
  );
}
